import styled from 'styled-components';
import { theme } from 'assets/styles/theme';
import { DeviceUp } from 'assets/styles/breakpoints';

export const Styled = styled.div`
  margin: 0 0 24px;
  overflow: hidden;

  @media ${DeviceUp.sm} {
    margin: 0 0 32px;
  }

  @media ${DeviceUp.lg} {
    margin: 0 0 40px;
  }
`;

export const MainHeading = styled.div`
  font-weight: 600;
  font-size: clamp(1.375rem, 4vw, 1.875rem);
  margin: 0 0 30px;

  @media ${DeviceUp.xl} {
    font-size: 2.25rem;
  }

  a {
    color: ${theme.secondary};
    font-size: ${theme.lgFontSize};
    font-weight: normal;
    display: block;
    margin: 8px 0 0;

    @media ${DeviceUp.xs} {
      display: inline-block;
      vertical-align: middle;
      margin: 4px 0 0 23px;
    }
    
    &:hover {
      color: ${theme.text};
    }
    i {
      font-size: 20px;
      padding: 0 0 0 7px;
      position: relative;
      top: 4px;
    }
  }

  span {
    display: block;
    @media ${DeviceUp.xs} {
      display: inline-block;
      vertical-align: middle;
    }
  }
`;

export const StatsHolder = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  width: 100%;
  max-width: 100%;

  @media ${DeviceUp.xs} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media ${DeviceUp.md} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media ${DeviceUp.lg} {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
`;

export const Block = styled.div`
  border-radius: 5px;
  border: ${theme.borderSecondary};
  min-height: 118px;
  margin: 0;
  padding: 18px 20px;
  overflow: hidden;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  .numbers {
    display: block;
    font-weight: 600;
    font-size: clamp(1.375rem, 5vw, 1.875rem);
    margin: 0 0 5px;

    @media ${DeviceUp.xl} {
      font-size: 2.25rem;
    }
  }
  .text-info {
    display: block;
    font-weight: 600;
    i {
      color: ${theme.MediumGray};
      position: relative;
      top: 3px;
      right: -4px;
      font-size: 16px;

      @media ${DeviceUp.xl} {
        top: 3px;
      }
    }
  }
`;
